const titleConfig = {
  "/login": "Login - Shippal",
  "/signup": "Signup - Shippal",
  "/reset": "Reset Password - Shippal",
  "/reset/confirm": "Confirm Password Reset - Shippal",
  "/dashboard": "Dashboard - Shippal",
  "/dashboard/quote": "Quote - Shippal",
  "/dashboard/ship": "Ship - Shippal",
  "/dashboard/orders": "Orders - Shippal",
  "/dashboard/orders/:orderId": "Order Details - Shippal",
  "/dashboard/settings": "Settings - Shippal",
};

export default titleConfig;
